import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  index: {},
};

export const quinIndexSlice = createSlice({
  name: "quinIndex",
  initialState,

  reducers: {
    setQuinIndexData: (state, action) => {
      const { item, value, type = "INDEX", date } = action.payload || {};
      if (!item) return;
      if (Array.isArray(state.index)) state.index = {};
      const timestamp = date ? date.slice(11, 19).replace(/:/g, "_") : "";
      const key = `${item}_${timestamp}`;
      state.index[key] = { item, value, type, date };
    },

    setQuinIndexSent: (state, action) => {
      state.indexSent = action.payload;
    },

    clearQuinIndex: (state) => {
      state.index = {};
    },
  },
});

export const { setQuinIndexData, clearQuinIndex, setQuinIndexSent } =
  quinIndexSlice.actions;

export default quinIndexSlice.reducer;
